export default {
    // In an array of items, add item.
    // Replace if item.id already exists
    updateOrCreateById(items, item) {
        const index = items.findIndex(x => x.id == item.id);
        if (index >= 0) {
            items[index] = item;
        } else {
            items.push(item);
        }
        return items;
    },
    deleteById(items, id) {
        const index = items.findIndex(x => x.id == id);
        if (index >= 0) {
            items.splice(index, 1);
        }
        return items;
    },
    // Used in sorting
    comparebyNameProperty(a, b) {
        const propertyname = 'name';
        if (a[propertyname] < b[propertyname]) return -1;
        if (a[propertyname] > b[propertyname]) return 1;
        return 0;
    }
};
